// React imports.
import React, { useMemo } from "react";

//library imports
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// App imports.
import { IndexHistory } from '../state'
import ReadingIndexValues from "./ReadingIndexValues";

interface BenefitTargetingComp2Props {
  history: IndexHistory;
}

function BenefitTargetingComp2({ history }: BenefitTargetingComp2Props) {
  // Add safety checks for potentially undefined values
  const latestYear = history.LatestYear || {};
  const fiscalYear = history.LatestYear && history.LatestYear.Year ? String(history.LatestYear.Year) : '';
  const selectedIndex = history.LatestYearSelectedIndex || 0;
  const natlAvgIndex = history.LatestYearNatlAvgIndex || 0;

  // Initialize options with useMemo to avoid recalculation
  const options = useMemo(() => {
    const baseOptions = {
      credits: {
        enabled: false
      },
      chart: {
        type: 'column',
      },
      title: {
        text: history.SelectedIndexString + ' Index'
      },
      xAxis: {
        labels: {
          enabled: true,
        },
        categories: [] as string[],
        crosshair: true
      },
      yAxis: {
        plotLines: [{
          color: '#FF0000',
          width: 2,
          value: 100,
          dashStyle: 'ShortDash',
        }],
        min: 0,
        max: 200,
        title: {
          text: history.SelectedIndexString + ' Index'
        }
      },
      series: [
        {
          name: history.SelectedIndexString + ' Index',
          data: [] as any[],
          showInLegend: false,
        }
      ],
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true
          }
        },
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
    };

    let dataArray: any[] = [];

    dataArray.push({
      y: +selectedIndex,
      color: 'grey'
    });
    baseOptions.xAxis.categories.push(history.GranteeName);

    if (+selectedIndex > 200) {
      baseOptions.yAxis.max = +selectedIndex + 30;
    }

    dataArray.push(natlAvgIndex);

    if (+natlAvgIndex > 200) {
      baseOptions.yAxis.max = +natlAvgIndex + 30;
    }

    baseOptions.xAxis.categories.push('Average for All States');

    baseOptions.series[0].data = dataArray;
    
    return baseOptions;
  }, [history, selectedIndex, natlAvgIndex]);

  return (
    <div >
      <h2>{history.SelectedIndexString}    Index – Comparing Your State to the Average for All States</h2>
      <br />
      {history.LatestYearNationalCompString}


      <br /><br />
      <div className="container">
        <div className="row">
          <div className="col-sm-4 font-weight-bold offset-sm-1 h5 text-right">FY {fiscalYear} {history.GranteeName}: {selectedIndex}</div>
          <div className="col-sm-6 font-weight-bold h5 text-left">FY {fiscalYear} AVERAGE FOR ALL STATES: {natlAvgIndex}</div>
        </div>
      </div>
      <br /><br />
      <div className="container">
        <div className="row">
          <div className="col-sm-7">
            <HighchartsReact highcharts={Highcharts} options={options} />
          </div>
          <div className="col-sm-5 takeaways">
            <ReadingIndexValues history={history} />
          </div>
        </div>
      </div>
      <br /><br />
      <p><span>Please click <em>Next </em>to continue.</span></p>
    </div>
  );
}

export default BenefitTargetingComp2;
